// export const ISDEV = false;
export const ISDEV = process.env.NODE_ENV === "development";
export const DEFAULT_LOCALE = "ru";

export const locales = [
  { _id: "ru", name: "Русский" },
  { _id: "en", name: "English" },
];

// GraphQL API URL for new system
export const API_URL = ISDEV
  ? "https://api.dev.restomenu.cc/graphql"
  : "https://api.dev.restomenu.cc/graphql";

// WebSocket URL for real-time features
export const WS_URL = ISDEV
  ? "ws://localhost:4000/graphql"
  : "wss://api.dev.restomenu.cc/graphql";
